import { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";

const dict = {
  ar: {
    brand: "رحّال",
    tagline: "دليلك الذكي لاكتشاف الشرق الأوسط",
    nav_explore: "استكشف",
    nav_planner: "خطط رحلتك",
    nav_assistant: "مساعد ذكي",
    nav_prices: "الأسعار",
    hero_title: "اكتشف الشرق الأوسط، سعر بسعر.",
    hero_sub: "دليل سفر عربي متكامل: أماكن سياحية، متوسط الأسعار اليومي، ومساعد ذكاء اصطناعي يجاوبك لحظياً.",
    hero_cta_explore: "ابدأ الاستكشاف",
    hero_cta_ai: "اسأل مساعد رحّال",
    search_placeholder: "ابحث عن مدينة أو معلم…",
    filter_country: "الدولة",
    filter_category: "التصنيف",
    all_countries: "كل الدول",
    trending: "الأكثر رواجاً",
    popular_destinations: "وجهات شائعة",
    view_details: "اعرف أكثر",
    add_to_trip: "أضف للرحلة",
    per_day: "لليوم",
    rating: "التقييم",
    best_time: "أفضل وقت للزيارة",
    price_guide: "دليل الأسعار",
    hotel: "الفندق",
    meal: "وجبة طعام",
    transport: "مواصلات يومياً",
    ticket: "تذكرة الدخول",
    budget: "اقتصادي",
    mid: "متوسط",
    luxury: "فاخر",
    tips: "نصائح سفر",
    trip_planner: "مخطط الرحلة",
    day: "اليوم",
    total_cost: "إجمالي التكلفة",
    save_trip: "احفظ الرحلة",
    empty_trip: "ابدأ بإضافة وجهات إلى رحلتك",
    remove: "إزالة",
    ai_title: "رحّال — مساعد السفر الذكي",
    ai_sub: "اسألني عن الجداول، الأسعار، الطعام، أو أي شيء يخص وجهتك.",
    ai_placeholder: "اكتب سؤالك هنا…",
    ai_send: "أرسل",
    ai_quick_1: "خطة 3 أيام في دبي",
    ai_quick_2: "أرخص وسائل النقل في القاهرة",
    ai_quick_3: "أفضل مطاعم شعبية في مراكش",
    ai_quick_4: "متى أزور كابادوكيا؟",
    ai_empty: "ابدأ محادثة، أو جرب أحد الاقتراحات أدناه",
    currency_conv: "محول العملات",
    from: "من",
    to: "إلى",
    amount: "المبلغ",
    result: "النتيجة",
    sponsored: "إعلان رعاية",
    footer_note: "رحّال © 2026 — دليل السفر الذكي للشرق الأوسط",
    prices_hub: "دليل أسعار المدن",
    monthly_avg: "المتوسط اليومي",
    lang_short: "AR",
  },
  en: {
    brand: "Rahhal",
    tagline: "Your smart guide to discovering the Middle East",
    nav_explore: "Explore",
    nav_planner: "Trip Planner",
    nav_assistant: "AI Assistant",
    nav_prices: "Prices",
    hero_title: "Discover the Middle East, price by price.",
    hero_sub: "A full Arabic-first travel guide: destinations, daily average costs and an AI concierge answering you instantly.",
    hero_cta_explore: "Start Exploring",
    hero_cta_ai: "Ask Rahhal AI",
    search_placeholder: "Search a city or landmark…",
    filter_country: "Country",
    filter_category: "Category",
    all_countries: "All countries",
    trending: "Trending now",
    popular_destinations: "Popular destinations",
    view_details: "View details",
    add_to_trip: "Add to trip",
    per_day: "per day",
    rating: "Rating",
    best_time: "Best time to visit",
    price_guide: "Price guide",
    hotel: "Hotel",
    meal: "Meal",
    transport: "Transport / day",
    ticket: "Entry ticket",
    budget: "Budget",
    mid: "Mid",
    luxury: "Luxury",
    tips: "Travel tips",
    trip_planner: "Trip Planner",
    day: "Day",
    total_cost: "Total estimated cost",
    save_trip: "Save trip",
    empty_trip: "Start by adding destinations to your trip",
    remove: "Remove",
    ai_title: "Rahhal — AI Travel Concierge",
    ai_sub: "Ask me about itineraries, prices, food, or anything about your destination.",
    ai_placeholder: "Type your question…",
    ai_send: "Send",
    ai_quick_1: "3-day plan in Dubai",
    ai_quick_2: "Cheapest transport in Cairo",
    ai_quick_3: "Best local food in Marrakech",
    ai_quick_4: "When to visit Cappadocia?",
    ai_empty: "Start a chat, or try one of the suggestions below",
    currency_conv: "Currency Converter",
    from: "From",
    to: "To",
    amount: "Amount",
    result: "Result",
    sponsored: "Sponsored",
    footer_note: "Rahhal © 2026 — Smart travel guide for the Middle East",
    prices_hub: "City Price Guide",
    monthly_avg: "Daily avg",
    lang_short: "EN",
  },
  fr: {
    brand: "Rahhal",
    tagline: "Votre guide intelligent pour découvrir le Moyen-Orient",
    nav_explore: "Explorer",
    nav_planner: "Planificateur",
    nav_assistant: "Assistant IA",
    nav_prices: "Tarifs",
    hero_title: "Découvrez le Moyen-Orient, prix par prix.",
    hero_sub: "Un guide de voyage complet : destinations, coûts quotidiens moyens et un concierge IA qui vous répond instantanément.",
    hero_cta_explore: "Commencer à explorer",
    hero_cta_ai: "Demander à l'IA Rahhal",
    search_placeholder: "Rechercher une ville ou un site…",
    filter_country: "Pays",
    filter_category: "Catégorie",
    all_countries: "Tous les pays",
    trending: "Tendances",
    popular_destinations: "Destinations populaires",
    view_details: "Voir les détails",
    add_to_trip: "Ajouter au voyage",
    per_day: "par jour",
    rating: "Note",
    best_time: "Meilleure période",
    price_guide: "Guide des prix",
    hotel: "Hôtel",
    meal: "Repas",
    transport: "Transport / jour",
    ticket: "Billet d'entrée",
    budget: "Économique",
    mid: "Moyen",
    luxury: "Luxe",
    tips: "Conseils de voyage",
    trip_planner: "Planificateur",
    day: "Jour",
    total_cost: "Coût total estimé",
    save_trip: "Enregistrer",
    empty_trip: "Ajoutez des destinations à votre voyage",
    remove: "Retirer",
    ai_title: "Rahhal — Concierge de voyage IA",
    ai_sub: "Posez-moi des questions sur les itinéraires, les prix, la gastronomie ou votre destination.",
    ai_placeholder: "Écrivez votre question…",
    ai_send: "Envoyer",
    ai_quick_1: "Plan de 3 jours à Dubaï",
    ai_quick_2: "Transport le moins cher au Caire",
    ai_quick_3: "Meilleurs plats locaux à Marrakech",
    ai_quick_4: "Quand visiter la Cappadoce ?",
    ai_empty: "Démarrez une conversation ou essayez une suggestion ci-dessous",
    currency_conv: "Convertisseur de devises",
    from: "De",
    to: "Vers",
    amount: "Montant",
    result: "Résultat",
    sponsored: "Sponsorisé",
    footer_note: "Rahhal © 2026 — Guide de voyage intelligent pour le Moyen-Orient",
    prices_hub: "Guide des prix par ville",
    monthly_avg: "Moy. / jour",
    lang_short: "FR",
  },
};

const LANG_ORDER = ["ar", "en", "fr"];

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("rahhal.lang");
    return LANG_ORDER.includes(saved) ? saved : "ar";
  });

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    localStorage.setItem("rahhal.lang", lang);
  }, [lang]);

  const t = useCallback((key) => dict[lang][key] ?? key, [lang]);
  const toggleLang = useCallback(() => {
    setLang((l) => {
      const idx = LANG_ORDER.indexOf(l);
      return LANG_ORDER[(idx + 1) % LANG_ORDER.length];
    });
  }, []);
  const nextLangLabel = dict[LANG_ORDER[(LANG_ORDER.indexOf(lang) + 1) % LANG_ORDER.length]].lang_short;

  const value = useMemo(
    () => ({ lang, t, toggleLang, setLang, nextLangLabel }),
    [lang, t, toggleLang, nextLangLabel]
  );

  return (
    <I18nContext.Provider value={value}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);

// Inline helper hook — pick a string for current lang; falls back to en, then ar.
export function useL() {
  const { lang } = useI18n();
  return ({ ar, en, fr }) => {
    if (lang === "fr") return fr ?? en ?? ar;
    if (lang === "en") return en ?? ar;
    return ar ?? en;
  };
}
